/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_Step_4_BodyInputs */

const da_forside_step_4_body = /** @type {(inputs: Forside_Step_4_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Print ét ark pr. elev med point, karakter og feedback – eller gem det som PDF.`)
};

/** @type {(inputs: Forside_Step_4_BodyInputs) => LocalizedString} */
const en_forside_step_4_body = da_forside_step_4_body;

/**

* @param {Forside_Step_4_BodyInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_step_4_body = /** @type {((inputs?: Forside_Step_4_BodyInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Step_4_BodyInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_step_4_body(inputs)
	return /** @type {LocalizedString} */ ("Print ét ark pr. elev med point, karakter og feedback – eller gem det som PDF.")
});